import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { CNContactRXImage } from 'src/app/models/cncontactrximage';

@Component({
  selector: 'app-rx-image-viewer',
  templateUrl: './rx-image-viewer.component.html',
  styleUrls: ['./rx-image-viewer.component.scss']
})
export class RxImageViewerComponent implements OnInit, OnChanges {

  private static readonly MIN_SCALE = 0.25;
  private static readonly MAX_SCALE = 8;
  private static readonly STEP = 1.25;

  @Input() image: CNContactRXImage;

  public scale = 1;
  public offsetX = 0;
  public offsetY = 0;

  private panning = false;
  private startX = 0;
  private startY = 0;

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(): void {
    this.reset();
  }

  public thumbnail(image?: CNContactRXImage): string {
    return image ? image.baseurl + '/' + image.filename : '';
  }

  public get transform(): string {
    return `translate(${this.offsetX}px, ${this.offsetY}px) scale(${this.scale})`;
  }

  public zoomIn(): void {
    this.setScale(this.scale * RxImageViewerComponent.STEP);
  }

  public zoomOut(): void {
    this.setScale(this.scale / RxImageViewerComponent.STEP);
  }

  public reset(): void {
    this.scale = 1;
    this.offsetX = 0;
    this.offsetY = 0;
  }

  public onWheel(event: WheelEvent): void {
    event.preventDefault();
    if (event.deltaY < 0) {
      this.zoomIn();
    } else {
      this.zoomOut();
    }
  }

  public onMouseDown(event: MouseEvent): void {
    if (this.scale <= 1) { return; }
    event.preventDefault();
    this.panning = true;
    this.startX = event.clientX - this.offsetX;
    this.startY = event.clientY - this.offsetY;
  }

  public onMouseMove(event: MouseEvent): void {
    if (!this.panning) { return; }
    this.offsetX = event.clientX - this.startX;
    this.offsetY = event.clientY - this.startY;
  }

  public onMouseUp(): void {
    this.panning = false;
  }

  private setScale(scale: number): void {
    this.scale = Math.min(RxImageViewerComponent.MAX_SCALE, Math.max(RxImageViewerComponent.MIN_SCALE, scale));
    if (this.scale <= 1) {
      this.offsetX = 0;
      this.offsetY = 0;
    }
  }
}
